import React from 'react';

const BusSvg = (props) => (
    <svg className="bus_svg__eds-icon--bus_svg" viewBox="0 0 24 24" {...props}>
        <path
            className="bus_svg__eds-icon--bus_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M5 5h14v6h-6.5V7h-1v4H5V5zm2 14c0 .6-.4 1-1 1s-1-.4-1-1v-1h2v1zm12 0c0 .6-.4 1-1 1s-1-.4-1-1v-1h2v1zm0-2H5v-5h14v5zm1-10V4H4v3H2v3h1V8h1v11c0 1.1.9 2 2 2s2-.9 2-2v-1h8v1c0 1.1.9 2 2 2s2-.9 2-2V8h1v2h1V7h-2z"
        />
        <g
            className="bus_svg__eds-icon--bus_dashes"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
        >
            <path d="M6 14h3v1H6zM15 14h3v1h-3z" />
        </g>
    </svg>
);

BusSvg.displayName = 'BusSvg';
export default BusSvg;
